import { PartialDelivery } from '@/coreDomainsModule/entities/partialDelivery';
import { OrderStatus } from '@/coreDomainsModule/entities/arrival';

/**
 *　分納のドメインロジック
 */
export class PartialDeliveryService {
  /**
   * 分納の数量を変更できるか
   * @param partialDelivery - 部分納情報
   */
  static canEditOrderAmount(partialDelivery: PartialDelivery): boolean {
    switch (partialDelivery.orderStatus) {
      case OrderStatus.QuantityConfirmed:
        return false;
      default:
        return true;
    }
  }

  /**
   * 分納の納期を変更できるか
   * @param partialDelivery - 部分納情報
   */
  static canEditDeliveryDate(partialDelivery: PartialDelivery): boolean {
    switch (partialDelivery.orderStatus) {
      case OrderStatus.DeliveryDateConfirmed:
        return false;
      default:
        return true;
    }
  }

  /**
   * 指定の発注ステータスに遷移可能かどうかを判定する
   * @param partialDelivery - 部分納情報
   * @param targetStatus - 遷移先のステータス
   */
  static canTransitionToStatus(partialDelivery: PartialDelivery, targetStatus: OrderStatus): boolean {
    switch (partialDelivery.orderStatus) {
      // 承認済みの場合は、納期回答待ち、数量回答待ち、確定に遷移可能
      case OrderStatus.ApprovedAwaitingDeliveryDate:
        switch (targetStatus) {
          case OrderStatus.QuantityConfirmed:
          case OrderStatus.DeliveryDateConfirmed:
          case OrderStatus.Confirmed:
          case OrderStatus.Delivered:
          case OrderStatus.DeliveryDelayed:
            return true;
          default:
            return false;
        }

      // 数量回答待ちの場合は、承認済み、納期回答待ち、確定、納入済みに遷移可能
      case OrderStatus.QuantityConfirmed:
        switch (targetStatus) {
          case OrderStatus.DeliveryDateConfirmed:
          case OrderStatus.Confirmed:
          case OrderStatus.ApprovedAwaitingDeliveryDate:
          case OrderStatus.Delivered:
          case OrderStatus.Confirmed:
          case OrderStatus.DeliveryDelayed:
            return true;
          default:
            return false;
        }

      // 納期回答待ちの場合は、承認済み、数量回答待ち、確定、納入済みに遷移可能
      case OrderStatus.DeliveryDateConfirmed:
        switch (targetStatus) {
          case OrderStatus.Confirmed:
          case OrderStatus.QuantityConfirmed:
          case OrderStatus.ApprovedAwaitingDeliveryDate:
          case OrderStatus.Delivered:
          case OrderStatus.Confirmed:
          case OrderStatus.DeliveryDelayed:
            return true;
          default:
            return false;
        }

      // 確定の場合は、承認済み、納期回答待ち、数量回答待ち、納入済みに遷移可能
      case OrderStatus.Confirmed:
        switch (targetStatus) {
          case OrderStatus.ApprovedAwaitingDeliveryDate:
          case OrderStatus.DeliveryDateConfirmed:
          case OrderStatus.QuantityConfirmed:
          case OrderStatus.Delivered:
          case OrderStatus.DeliveryDelayed:
            return true;
          default:
            return false;
        }

      case OrderStatus.Delivered:
        switch (targetStatus) {
          // 戻せる
          case OrderStatus.ApprovedAwaitingDeliveryDate:
          case OrderStatus.DeliveryDateConfirmed:
          case OrderStatus.QuantityConfirmed:
          case OrderStatus.Confirmed:
          case OrderStatus.DeliveryDelayed:
            return true;
          default:
            return false;
        }

      case OrderStatus.DeliveryDelayed:
        switch (targetStatus) {
          case OrderStatus.ApprovedAwaitingDeliveryDate:
          case OrderStatus.DeliveryDateConfirmed:
          case OrderStatus.QuantityConfirmed:
          case OrderStatus.Confirmed:
          case OrderStatus.Delivered:
            return true;
          default:
            return false;
        }

      default:
        return false;
    }
  }
}
